import React from 'react';
import styled, { css } from 'styled-components';
import chroma from 'chroma-js';

const color = chroma('#86e2b1');
const activeColor = color.darken(0.5);

const hoverStyles = css`
  &:hover {
    .cls-1 {
      fill: ${activeColor.hex()};
    }
  }
`;

export default styled(({ isHoveringFiles, noHover, ...rest }) => (
  <svg {...rest} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 104.41 94.89">
    <rect className="cls-1" x="1.22" width="101.97" height="21.46" rx="4.58" ry="4.58" />
    <path
      className="cls-1"
      d="M109.83,111.62H20.17c-2,0-3.61-2.06-3.61-4.58V21.32c0-2.52,1.63-4.58,3.61-4.58h89.67c2,0,3.61,2.06,3.61,4.58V107C113.45,109.56,111.82,111.62,109.83,111.62Z"
      transform="translate(-12.79 -16.74)"
    />
    <line className="cls-2" y1="21.71" x2="104.41" y2="21.71" />
    <path
      className="cls-3"
      d="M78.87,90.13l-.19-31.26a1,1,0,0,1,.28-.7l6.79-7a1,1,0,0,1,1.43,0l6.87,6.94a1,1,0,0,1,.29.7L94.53,90a1,1,0,0,1-1,1l-13.67.08A1,1,0,0,1,78.87,90.13Z"
      transform="translate(-12.79 -16.74)"
    />
    <circle className="cls-1" cx="86.51" cy="58.75" r="2.75" transform="translate(-13.14 -16.22) rotate(-0.34)" />
    <line className="cls-2" x1="73.39" y1="37.4" x2="73.39" y2="22.93" />
  </svg>
))`
  width: ${({ size }) => size || '60px'};
  height: ${({ size }) => size || '60px'};

  .cls-1 {
    fill: ${({ isHoveringFiles }) => (isHoveringFiles ? activeColor.hex() : color.hex())};
  }

  ${({ noHover }) => !noHover && hoverStyles}

  &:active {
    .cls-1 {
      fill: ${color.hex()};
    }
  }

  .cls-2 {
    fill: none;
    stroke: #fff;
    stroke-miterlimit: 10;
    stroke-width: 3px;
  }

  .cls-3 {
    fill: #fff;
  }
`;
